// import { ConfigMurucaResourceLayout } from '@net7/boilerplate-muruca';

export default {
  title: 'Autore antico',
  tabs: 'ancient_author',
  type: 'ancient_author',
  sections: {
    top: [
      {
        id: 'header',
        type: 'title',
        grid: null,
      },
      {
        id: 'editor_metadata',
        type: 'metadata',
      },
      {
        id: 'tab-bar',
        type: 'tabs'
      }
    ],
    content: [
      {
        id: 'metadata-scheda',
        type: 'metadata',
        options: {
          readmore: {
            height: 250,
            labels: {
              more: 'readmore#more',
              less: 'readmore#less'
            }
          }
        },
      },
      {
        id: 'collection-bibliography-ancient-author',
        type: 'collection',
        grid: 1,
        title: 'resource#collection_bibliography_ancient_author',
        options: {
          classes: 'mr-item-preview-bibliography',
          itemPreview: {
            limit: 9999,
            striptags: false,
          },
        },
      },
      {
        id: 'collection-bibliography-mediator',
        type: 'collection',
        grid: 1,
        title: 'resource#collection_bibliography_mediator',
        options: {
          classes: 'mr-item-preview-bibliography',
          itemPreview: {
            limit: 9999,
            striptags: false,
          },
        },
      },
      {
        id: 'collection-bibliography-critical',
        type: 'collection',
        grid: 1,
        title: 'resource#collection_bibliography_critical',
        options: {
          classes: 'mr-item-preview-bibliography',
          itemPreview: {
            limit: 9999,
            striptags: false,
          },
        },
      },
    ],
  },
};
